import React from 'react';
import Component from '@vfuk/core-link-with-icon';
const LinkWithIcon = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default LinkWithIcon;
